import { render, staticRenderFns } from "./Uploader.vue?vue&type=template&id=18868565&scoped=true&lang=pug"
import script from "./Uploader.vue?vue&type=script&lang=ts"
export * from "./Uploader.vue?vue&type=script&lang=ts"
import style0 from "./Uploader.vue?vue&type=style&index=0&id=18868565&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18868565",
  null
  
)

export default component.exports